module.exports = __webpack_public_path__ + "static/media/pp_clear_gaint_straw2.56c59454.png";